import { Injectable } from '@angular/core';
import { CustomHttpClient } from './custom-http-client.service';

/**
 * Clinical data returned by the single ai_context backend endpoint.
 * Used to enrich AI suggested-prompt requests with patient context.
 */
export interface PatientAiContext {
  age?: number | null;
  sex?: string | null;
  latest_vitals?: {
    vital_sign: string;
    short: string;
    value: string;
    unit: string;
    recorded_at: string;
  }[];
  allergies?: { name: string; status: string }[];
  medications?: { name: string; status: string }[];
  problems?: { name: string; status: string }[];
}

/**
 * Fetches a single endpoint that returns all patient AI context
 * (demographics + latest vitals + allergies + medications + problems).
 *
 * Rails endpoint: GET /api/v1/patients/ai_context?patient_id=<id>
 */
@Injectable({
  providedIn: 'root'
})
export class PatientAiContextService {

  constructor(private http: CustomHttpClient) {}

  /**
   * Retrieve combined patient AI context for the given patient ID.
   * Single HTTP call – no need to fan out to multiple endpoints.
   */
  getAiContext(patientId: number): Promise<PatientAiContext> {
    return this.http.get(`patients/ai_context?patient_id=${patientId}`)
      .toPromise()
      .then((response: PatientAiContext) => response)
      .catch(err => {
        console.error('❌ Failed to fetch patient AI context:', err);
        // Return empty context so the AI request can still proceed
        return {} as PatientAiContext;
      });
  }
}
